import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import Block from "./Block";

export default function BlockTabs({children, defaultActiveKey, ...props}) {

  const [activeKey, setActiveKey] = useState(defaultActiveKey);

  const tabs = children.map(child => ({eventKey: child.key, title: child.props.title}));

  useEffect(() => {
    if (props.activeKey) {
      setActiveKey(props.activeKey)
    }
  }, [props.activeKey])

  return <Tab.Container defaultActiveKey={defaultActiveKey} activeKey={activeKey} onSelect={setActiveKey}>
    <Block navbar={<TabNavBar tabs={tabs} />} {...props}>
      <Tab.Content>
        {children.map(child => <Tab.Pane key={child.key} eventKey={child.key}>
          {child}
        </Tab.Pane>)}
      </Tab.Content>
    </Block>
  </Tab.Container>
}

function TabNavBar({tabs}) {
  return <Nav>
    {tabs.map(tab => <Nav.Item key={tab.eventKey} >
      <Nav.Link eventKey={tab.eventKey}>{tab.title}</Nav.Link>
    </Nav.Item>)}
  </Nav>
}

BlockTabs.propTypes = {
  title: PropTypes.node,
  defaultActiveKey: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.element).isRequired
}


